import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutComponent } from '../about/about.component';
import { KeyPlatformFeaturesComponent } from '../key-platform-features/key-platform-features.component';
import { FooterComponent } from '../../../shared/components/footer/footer.component';

@Component({
  selector: 'app-about-us-home',
  standalone: true,
  imports: [
    CommonModule,
    AboutComponent,
    KeyPlatformFeaturesComponent,
    FooterComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class AboutUsHomeComponent {}
